import { render, staticRenderFns } from "./AbsenceRejectedDayLegend.vue?vue&type=template&id=d43bea2c&"
import script from "./AbsenceRejectedDayLegend.vue?vue&type=script&lang=js&"
export * from "./AbsenceRejectedDayLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d43bea2c')) {
      api.createRecord('d43bea2c', component.options)
    } else {
      api.reload('d43bea2c', component.options)
    }
    module.hot.accept("./AbsenceRejectedDayLegend.vue?vue&type=template&id=d43bea2c&", function () {
      api.rerender('d43bea2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/components/day-legend/AbsenceRejectedDayLegend.vue"
export default component.exports